import type { ListingProduct } from '~/models/ListingProduct.api.model';
import FetchFactory from '../factory';

const CONTROLLER = '/api-electra/AccessoryPage';

class AccessoryPageModule extends FetchFactory<any> {
  async getAccessoryByProductLinkUrl(url: string): Promise<ListingProduct> {
    const parsedUrl = url.replaceAll('/', '%2F');
    const requestUrl = `${CONTROLLER}/GetAccessoryByProductLinkUrl?productLinkUrl=${parsedUrl}`;

    return await this.get(requestUrl);
  }
}
export default AccessoryPageModule;
